import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestNavMenuAddLinksPost = {
    path: "/nav-menu/add-links",
    method: RouteHttpVerb.POST
};
export { locationRestNavMenuAddLinksPost };
